import { Union } from 'utils/types';

export const SortingOrder = Object.freeze({
  clinicScoreDesc: 'clinicScoreDesc',
  distanceAsc: 'distanceAsc',
  priceAsc: 'priceAsc',
  openedDateDesc: 'openedDateDesc',
  openedDateAsc: 'openedDateAsc',
  reviewCountDesc: 'reviewCountDesc',
  ratingMeanDesc: 'ratingMeanDesc',
});
export type SortingOrderType = Union<typeof SortingOrder>;

export const SortingOrderLabels = Object.freeze({
  [SortingOrder.clinicScoreDesc]: '추천순',
  [SortingOrder.distanceAsc]: '거리순',
  [SortingOrder.priceAsc]: '가격 낮은 순',
  [SortingOrder.openedDateDesc]: '신규 병원순',
  [SortingOrder.openedDateAsc]: '개원 연도순',
  [SortingOrder.reviewCountDesc]: '리뷰 많은 순',
  [SortingOrder.ratingMeanDesc]: '평점 높은 순',
});

export type SortingWithDistance = {
  sorting: SortingOrderType;
  distance?: number;
};
